import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { registerServiceWorker } from './pwa'
import './styles/global.css'

createApp(App).use(router).mount('#app')

// PWA : sans effet en natif et en dev (voir src/pwa.ts)
void registerServiceWorker()
